import styled from 'styled-components'

export const LayoutAuth = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  > div {
    height: 100%;
  }

  > div:nth-child(1) {
    padding: 0;
  }

  @media screen and (max-device-width: 400px), screen and (max-width: 400px) {
    position: fixed;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    height: auto;

    > div {
      height: auto;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Layout/Auth/index.js